import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { DialogInput, RequiredDialogSelect, RequiredDialogInput, handleInputChange } from '../DialogInputs';
import CommonConfigDialog from './CommonConfigDialog';
import SiteOrBusinessUnitSelect from '../SiteOrBusinessUnitSelect';
import { useQirStates, useSaveQIRStatus, useDeleteQIRStatus } from '../../../../hooks/useQIRStatus';
import { useTranslation } from 'react-i18next';

function QIRStatusEditDialog({ dialogData, setDialogData, showDialog, closeDialog }) {
    const { t } = useTranslation();
    const [fieldErrors, setFieldErrors] = useState({});
    const { saveQIRStatus } = useSaveQIRStatus();
    const { deleteFunction } = useDeleteQIRStatus(dialogData);
    const { qirStates, loading } = useQirStates();

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    };

    if (loading) {
        return (
            <CommonConfigDialog title={"Status - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveQIRStatus} canDelete deleteFunction={deleteFunction} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} >
                <div className="d-flex justify-content-center">
                    <Spinner animation="border" />
                </div>
            </CommonConfigDialog>
        );
    }

    return (
        <CommonConfigDialog title={"Status - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveQIRStatus} canDelete deleteFunction={deleteFunction} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors} >
            <RequiredDialogInput controlId="formStatusName" title="Name" placeholder="Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <SiteOrBusinessUnitSelect controlIdPrefix="AffectedArea" dialogData={dialogData} setDialogData={setDialogData} fieldErrors={fieldErrors} />
            <DialogInput controlId="formAffectedAreaDisplay" title="Display" placeholder="Display" name="display" value={dialogData.display} error={fieldErrors.display} onChange={onChange} />
            <DialogInput controlId="formAffectedAreaTranslationKey" title="Translation Key" placeholder="Translation.Key" name="translationKey" value={dialogData.translationKey} error={fieldErrors.translationKey} onChange={onChange} />
            <RequiredDialogSelect controlId="stateId" title="State" name="stateId" value={dialogData.stateId && dialogData.stateId} onChange={onChange} error={fieldErrors.stateId}>
                <option key="0" value="">{t('Application.Controls.DefaultSelect')}</option>
                {qirStates.map((state) => <option key={state.id} value={state.id}>{state.name}</option>)}
            </RequiredDialogSelect>
        </CommonConfigDialog>
    );
}

export default QIRStatusEditDialog;